<template>
    <div class="body">
        <div class="search-box">
            <div>
                <span class="title">姓名/手机号/身份证/学号：</span>
                <el-input class="search-input"  v-model="searchData" placeholder="请输入姓名/手机号/身份证/学号" clearable @change="getData"></el-input>
            </div>
            <div>
                <el-button class="primary-btn" style="margin-left: 16px" @click="reset()">重置</el-button>
                <el-button type="primary" style="margin-left: 16px" @click="getData()">查询</el-button>
            </div>
        </div>

        <div class="container">
            <div class="tab-box">
                <div class="tab">{{majorName}}</div>
<!--                <div class="tab">{{semesterName}}</div>-->
            </div>
            <el-table
                    :data="tableData"
                    class="table"
                    border
                    :cell-style="{color:'#666666',fontSize:'14px'}"
                    :header-cell-style="{background:'#eef1f6',color:'#333333',height:'49px',fontWeight:500,fontSize:'14px'}">
                <el-table-column prop="stu_name" label="学生名字" width="100px"  align='center'></el-table-column>
                <el-table-column prop="phone" label="手机号" width="120px" align='center'></el-table-column>
                <el-table-column prop="id_card" label="身份证号" width="170px" align='center'></el-table-column>
                <el-table-column prop="stu_id" align='center' label="学号"></el-table-column>
                <el-table-column prop="instru_name" label="指导老师" width="100px" align='center'></el-table-column>

                <el-table-column prop="topic_name" label="论文选题" align='center'></el-table-column>
                <el-table-column prop="thesis_name" label="学生论文" align='center'>
                    <template slot-scope="scope">
                        <a style="color: #3476FF" :href="scope.row.thesis_url" target="_blank">{{scope.row.thesis_name}}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="论文分数" width="80px" align='center'>
                     <template slot-scope="scope">
                          <div :class="scope.row.score>=80?'color-blue':scope.row.score<60?'color-red':'color-green'">{{scope.row.score}}</div>
                          </template>
                </el-table-column>

                <el-table-column prop="state" label="审核状态" width="120px"  align='center'>
                    <template slot-scope="scope">
                      <div :class="scope.row.state==1?'color-green':scope.row.state==2?'color-red':'color-blue'"> {{thesisStateHash[scope.row.state]}} </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="140px" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                                :disabled="!scope.row.thesis_url || org != accountOrg"
                                type="primary"
                                @click="edit(scope.row)"
                        >论文审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page=pageIndex
                        :page-size=10
                        :total=pageTotal
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>


        <el-dialog :close-on-click-modal='false' :close-on-press-escape='false'
                title="报告需知"
                :visible.sync="dialogVisible"
                width="440px"
                :before-close="dialogClose">
            <el-form ref="form" :model="form" label-width="90px" >
                <el-form-item class="form-item" label="姓名：" prop="stu_name">
                    <el-input disabled v-model="form.stu_name"  style="width: 240px"></el-input>
                </el-form-item>

                <el-form-item class="form-item" label="论文分数：" prop="score">
                    <el-input-number :controls=false :min="0" :max="100" v-model="form.score" class="input-number" style="width: 240px;"></el-input-number>
                </el-form-item>
                <el-form-item class="form-item" label="审核状态：" prop="person_num">
                    <el-select filterable clearable v-model="form.state" placeholder="请选择审核状态" style="width: 240px">
                        <el-option
                                v-for="item in thesisStateData"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose()">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        name: 'StudentThesis',
        data() {
            return {
                org:0,
                thesisStateData:[],
                thesisStateHash:[],
                value1:'',
                accountOrg:0,
                pageIndex: 1,
                pageSize: 10,
                pageTotal:0,
                tableData: [],
                dialogVisible:false,
                searchData:'',
                form:{
                    stu_name:'',
                    score:0,
                    state:0
                },
                options: [{
                    value: '1',
                    label: '审核中'
                }, {
                    value: '2',
                    label: '未审核'
                }, {
                    value: '3',
                    label: '审核通过'
                }],
            };
        },

        created() {
            this.getTransitionValue()
            this.accountOrg = localStorage.getItem("org")
            this.grade = this.$route.query.grade
            this.majorId = this.$route.query.major_id
            this.org = this.$route.query.org
            this.majorName = this.$route.query.majorName
            this.getData();
        },
        watch: {
            $route () {
                this.grade = this.$route.query.grade
                this.majorId = this.$route.query.major_id
                this.org = this.$route.query.org
                this.majorName = this.$route.query.majorName

                this.getData();
            }
        },
        methods: {
            getData() {
                this.$get(this.BASEURL+`/thesis/student?page=${this.pageIndex}&major_id=${this.majorId}&grade=${this.grade}&content=${this.searchData}`).then((res)=>{
                    if(res.code === 200){
                        this.tableData = res.data
                        this.pageTotal = res.total
                    }else{
                        console.log(res.error);
                    }
                });
            },
            //获取转换值列表
            getTransitionValue(){
                let data = ['thesis_state']
                this.$post(this.BASEURL + '/assets/transition/GET',
                    {
                        'key_list': data
                    }
                ).then((res) => {
                    if (res.code === 200) {
                        this.thesisStateData = res.data.thesis_state[0]
                        this.thesisStateHash = res.data.thesis_state[1]
                    } else {
                        console.log(res.error);

                    }
                });
            },
            save(){
                this.$put(this.BASEURL+`/thesis/student`,this.form).then((res)=>{
                    if(res.code === 200){
                        this.dialogVisible = false
                        this.getData()
                    }else{
                        console.log(res.error);

                    }
                });
            },
            edit(data){
                if (data.score === null || data.score === ''){
                    this.form.score = 0
                }else{
                    this.form.score = data.score
                }
                this.form.stu_name = data.stu_name
                this.form.state = data.state
                this.form.stu_thesis_id = data.stu_thesis_id
                this.dialogVisible = true
            },
            reset(){
                this.searchData = ''
                this.getData()
            },

            handlePageChange(val) {
                this.pageIndex = val
                this.getData();
            },
            dialogClose(){
                this.dialogVisible = false
            },
        }
    };
</script>

<style lang="scss" scoped>
    /deep/ .input-number .el-input .el-input__inner{
        text-align: left
    }
    .body{
        button{
            padding: 8px 15px;
            font-size: 14px;
        }
    }
    .tab-box{
        display: flex;
        align-items: center;
        margin-bottom: 28px;
        .tab{
            color: #666666;
            font-size: 14px;
            text-align: center;
            padding: 0 20px;
            height: 32px;
            line-height: 32px;
            background-color: #F5F7FA;
            margin-left: 16px;
            border-radius: 5px;
        }
    }
    .search-box{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        padding: 28px 30px;
        margin-top: $distance;
        margin-bottom: $distance;
        border-radius: $radius;
        .search-input{
            width: 240px;
            margin-right: 16px;
        }
        .title{
            font-size:$title-size;
            line-height:15px;
            color: #343434;
        }
    }
    .btn-box{
        display: flex;
        margin-bottom: 16px;
    }
    .primary-btn{
        border-color: #409EFF;
        color: #409EFF;
    }
    /deep/.teacher .el-input__inner{
        border-radius: 5px 0 0 5px;
    }
    /deep/.topic .el-input__inner{
        border-radius: 0;
        margin-left: -1px;
    }
    /deep/.direction .el-input__inner{
        margin-left: -2px;
        border-radius: 0 5px 5px 0;
    }

</style>
